import React from 'react';

export const DeleteServiceModal = ({ selectedService, deleteService }) => {
	return (
		<div className="modal fade px-0" id="deleteServiceModal" aria-labelledby="deleteServiceLabel" aria-hidden="true">
			<div className="modal-dialog px-2">
				<div className="modal-content">
					<header className="modal-header">
						<div className="alert bg-alert-danger rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Delete service</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-danger text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="deleteServiceLabel">Supprimer le service</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body text-center">						
						<div className="fs-sm ls-n1">Etes-vous sûr(e) de vouloir supprimer le service <strong>{selectedService.name}</strong>?</div>
						<div className="fs-3 o-60">Cette action est irréversible.</div>
					</div>
					<div className="modal-footer justify-content-center">
						<button type="button" className="btn btn-light" data-dismiss="modal" aria-label="Close">Annuler</button>
						<button type="button" className="btn btn-danger" data-dismiss="modal" onClick={() => deleteService(selectedService)}>Supprimer</button>
					</div>
				</div>
			</div>
		</div>
	);
};